import { FaPhoneAlt } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import ContactForm from "../forms/contactForm";
import CtaOffer from "../common/ctaOffer";

function Offer2CzyszczenieDzialek() {
  return (
    <>
      {/* HERO */}
      <section className="relative overflow-x-hidden flex flex-col lg:flex-row items-center justify-between lg:min-h-[60vh] p-6 lg:px-12 lg:pt-48 lg:pb-36 gap-6">
        <img
          className="absolute w-full h-full object-cover z-10 top-0 left-0"
          src="https://magazyn.drzewus.pl/wp-content/uploads/2025/02/czyszczenie-dzialek-Large.jpeg"
          alt="Czyszczenie działek - porządkowanie terenu - Drzewus"
        />
        <div className="w-full h-full object-cover z-20 absolute top-0 left-0 gradient-green-ltr"></div>
        <div className="flex flex-col items-start justify-center gap-2 z-30">
          <h1 className="text-3xl lg:text-6xl text-white text-left">
            Oczyszczanie i czyszczenie działek pod budowę Gdańsk, Gdynia
          </h1>
          <h2 className="text-xl lg:text-3xl text-white text-left">
            Kompleksowe przygotowanie zaniedbanego terenu pod inwestycję
          </h2>
          <p className="text-white text-base lg:text-xl max-w-[850px] text-left">
            Kupiłeś zarośniętą działkę na Kaszubach, w Gdańsku, Gdyni lub Wejherowie i planujesz rozpoczęcie budowy? DRZEWUS oferuje kompleksowe czyszczenie i oczyszczanie działek z zarośli, krzewów, kamieni i dzikiej roślinności. Zastosowanie <a href="/oczyszczanie-terenu/mulczer-lesny" className="underline hover:opacity-80">mulczera leśnego</a> oraz minikoparek pozwala nam w krótkim czasie zamienić nieużytek w czysty plac budowy.
          </p>
          <a href="#wiecej">
            <button className="button-yellow">Dowiedz się więcej</button>
          </a>
        </div>
        <div className="z-30 max-w-[500px] flex flex-col items-center justify-center">
          {" "}
          <ContactForm />
        </div>
      </section>
      {/* CONTENT */}
      <section
        id="wiecej"
        className="p-6 lg:px-24 lg:py-12 grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-12"
      >
        <div className="lg:col-span-1 flex flex-col gap-6">
          <div className="flex flex-col gap-2 p-6 rounded-xl bg-green w-full">
            <a
              href="#1"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Co robi mulczer leśny
            </a>
            <a
              href="#2"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Gdzie sprawdzi się mulczowanie terenu?
            </a>
            <a
              href="#3"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Tereny, które oczyści mulczer leśny
            </a>
            <a
              href="#4"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Jakie działki oczyszczamy
            </a>
            <a
              href="#5"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Oczyszczanie działki budowlanej pod inwestycje
            </a>
            <a
              href="#6"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Co daje mulczowanie
            </a>
            <a
              href="#7"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Mulczer leśny czyli szybka wycinka samosiejek
            </a>
            <a
              href="#8"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Korzyści z zastosowania mulczera
            </a>
            <a
              href="#9"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Czy wycinka zarośli i drzew jest ekologiczna?
            </a>
            <a
              href="#10"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Wycinka samosiejek cennik – od czego zależy?
            </a>
            <a
              href="#11"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Co wpływa na koszt oczyszczenia działki?
            </a>
          </div>
          <CtaOffer />
        </div>
        <div className="lg:col-span-2 flex flex-col items-start justify-start text-left gap-2 content-offer">
          <p>
            Nasza firma dysponuje zaawansowanym zapleczem technicznym, które pozwala na błyskawiczne i dokładne usunięcie dzikiej roślinności, zarośli i krzaków z dowolnego terenu. Specjalizujemy się w pełnym przygotowaniu gruntów pod inwestycje – od usunięcia krzewów, przez ukształtowanie powierzchni, aż po późniejsze zagospodarowanie zieleni.
          </p>

          <p>
            Podejmujemy się także usuwania drzew metodami tradycyjnymi oraz technikami linowymi w trudno dostępnych miejscach. Kompleksowo pomagamy w dopełnieniu formalności urzędowych. Dzięki stałej współpracy z dendrologiem i ornitologiem sprawnie uzyskujemy niezbędne zezwolenia na wycinkę.
          </p>

          <h2>Skuteczne oczyszczanie terenu z samosiejek</h2>

          <p>
            Dzięki specjalistycznym maszynom sprawnie pozbywamy się gęstych zarośli, karczujemy pnie i krzewy. Wycięty materiał poddajemy zrębkowaniu bezpośrednio na miejscu, a rozdrobnione gałęzie i biomasę możemy rozrzucić po gruncie lub wywieźć. Mulczowanie poprawia jakość gleby i znakomicie wyrównuje powierzchnię działki, eliminując problem składowania i utylizacji odpadów zielonych.
          </p>

          <h3 id="1">Co robi mulczer leśny</h3>
          <ul>
            <li>kosi zarośla</li>
            <li>karczuje samosiejki</li>
            <li>wycina drzewa</li>
            <li>oczyszcza teren</li>
            <li>kosi nieużytki</li>
            <li>rozdrabnia gałęzie</li>
            <li>rekultywuje działki</li>
            <li>usuwa pozostałości pozrębowe</li>
          </ul>

          <p>
            Z pomocą naszych maszyn skutecznie oczyszczamy nawet najbardziej zaniedbane obszary. Pozwala to na pełne odzyskanie przestrzeni bez uciążliwego wywożenia odpadów. Realizujemy zlecenia na zróżnicowanym terenie – bez problemu oczyszczamy strome skarpy, rowy, pobocza oraz nasypy kolejowe czy drogowe.
          </p>

          <p>
            Naszą ofertę kierujemy do klientów indywidualnych, deweloperów oraz instytucji publicznych. Głównym obszarem naszego działania jest województwo pomorskie, w tym Gdańsk, Gdynia, Sopot i okoliczne powiaty, jednak przy większych zleceniach dojeżdżamy na terenie całego Pomorza oraz województw ościennych.
          </p>

          <h2 id="2">Gdzie sprawdzi się mulczowanie terenu?</h2>

          <p>
            Maszyna wyposażona w szybkotnący rotor bez problemu kruszy i miesza z gruntem samosiejki, zarośla oraz mniejsze drzewa. W wyniku tego procesu powstaje jednolity grunt pozbawiony wystających gałęzi czy pniaków, idealnie przygotowany pod dalsze planowanie przestrzenne.
          </p>

          <h3 id="3">Tereny, które oczyści mulczer leśny</h3>
          <ul>
            <li>łąki</li>
            <li>skarpy</li>
            <li>rowy melioracyjne</li>
            <li>rowy przydrożne</li>
            <li>nasypy kolejowe</li>
            <li>wały przeciwpowodziowe</li>
            <li>pasy przeciwpożarowe</li>
            <li>tereny pod farmy wiatrowe</li>
            <li>tereny przy zbiornikach wodnych</li>
          </ul>

          <p>
            Przygotowujemy również tereny rekreacyjne, ścieżki leśne oraz pasy zieleni. Chętnie podejmujemy się karczowania dużych obszarów pod inwestycje infrastrukturalne, drogowe czy komercyjne. Nasze wsparcie pozwala na szybki start właściwych prac budowlanych.
          </p>

          <h3 id="4">Jakie działki oczyszczamy</h3>
          <ul>
            <li>działki rolne</li>
            <li>działki budowlane</li>
            <li>działki inwestycyjne</li>
            <li>działki siedliskowe</li>
            <li>działki leśne</li>
            <li>działki pod liniami wysokiego napięcia</li>
            <li>działki pod inwestycje drogowe</li>
            <li>działki wojskowe</li>
          </ul>

          <h2 id="5">Oczyszczanie działki budowlanej pod inwestycje</h2>

          <p>
            Po zakończeniu prac oczyszczających teren staje się od razu zdatny pod budowę lub nasadzenia. Ponieważ świadczymy kompleksowe usługi kształtowania krajobrazu, możemy od razu przejść do niwelacji, drenażu lub aranżacji nowej zieleni przydomowej.
          </p>

          <h3 id="6">Co daje mulczowanie</h3>
          <ul>
            <li>poprawia jakość gleby</li>
            <li>zmniejsza parowanie wody</li>
            <li>nie dopuszcza do rozwoju chwastów</li>
            <li>zapobiega erozji wodnej</li>
            <li>przygotowuje działkę pod uprawy lub inwestycje</li>
          </ul>

          <h2 id="7">Mulczer leśny czyli szybka wycinka samosiejek</h2>

          <p>
            Koszt usługi oczyszczania działki wyceniamy indywidualnie na podstawie jej powierzchni i stopnia zarośnięcia. Dla dużych obszarów najwygodniej stosować stawkę za hektar, natomiast mniejsze parcele wyceniamy za metr kwadratowy, co pozwala zachować optymalne warunki finansowe dla każdego klienta.
          </p>

          <h3 id="8">Korzyści z zastosowania mulczera</h3>
          <ul>
            <li>Wzbogaca glebę biomasą z ściętych drzew i krzewów</li>
            <li>Brak odpadów do wywiezienia po wycince</li>
            <li>Opóźnia wzrost chwastów</li>
            <li>
              Szybko usuwa niepotrzebną roślinność, która utrudnia poruszanie
              się po działce
            </li>
            <li>Jest bardzo zwrotny - może ominąć wybrane rośliny</li>
            <li>
              Zyskasz równą powierzchnię, którą będziesz mógł kosić zwykłą
              kosiarką
            </li>
          </ul>

          <p>
            Użycie specjalistycznego sprzętu, takiego jak Bobcat T66 z głowicą mulczującą, eliminuje potrzebę ręcznego wycinania samosiejek. Efekt to idealnie czysta i gotowa do zagospodarowania przestrzeń.
          </p>

          <h2 id="9">Czy wycinka zarośli i drzew jest ekologiczna?</h2>

          <p>
            Warto pamiętać, że spalanie gałęzi i pozostałości roślinnych bezpośrednio na działce jest niezgodne z prawem i grozi karami finansowymi. Zamiast płacić za kosztowny transport na składowisko, oferujemy bezproblemowe rozdrobnienie materiału na miejscu.
          </p>

          <h2 id="10">Wycinka samosiejek cennik – od czego zależy?</h2>

          <h3 id="11">Co wpływa na koszt oczyszczenia działki?</h3>
          <ul>
            <li>Wielkość powierzchni do oczyszczenia</li>
            <li>Rodzaj roślin do usunięcia</li>
            <li>Rodzaj terenu</li>
            <li>Dodatkowe zanieczyszczenia</li>
            <li>Miejscowość</li>
          </ul>
        </div>
      </section>
      <section className="p-6 lg:px-24 lg:py-12 flex flex-col gap-6">
        <div className="flex flex-col items-center justify-center mb-6">
          <h2 className="uppercase color-yellow text-xl text-center">
            Nasze realizacje
          </h2>
          <h3 className="text-3xl lg:text-5xl color-green text-center">
            Spójrz jak pomogliśmy<br></br>
            <span className="color-yellow">naszym Klientom</span>
          </h3>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[500px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/04/mulczowanie-1.jpeg"
              alt="Czyszczenie działki - mulczowanie terenu nr 1"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[500px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/04/mulczowanie-2.jpeg"
              alt="Czyszczenie działki - mulczowanie terenu nr 2"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[500px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/04/mulczowanie-3.jpeg"
              alt="Czyszczenie działki - mulczowanie terenu nr 3"
              className="h-full object-cover w-full"
            />
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">

        </div>
      </section>
    </>
  );
}

export default Offer2CzyszczenieDzialek;
